import { render } from "./SignInButton.vue?vue&type=template&id=24d27aea&scoped=true"
import script from "./SignInButton.vue?vue&type=script&lang=js"
export * from "./SignInButton.vue?vue&type=script&lang=js"

import "./SignInButton.vue?vue&type=style&index=0&id=24d27aea&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24d27aea"]])

export default __exports__